import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import { fromJS } from 'immutable';
import Button from '@mui/material/Button';

import { setDialogContentProp } from '../../actions/dialog';
import CommentsList from '../Comments/CommentsList';

const setComment = setDialogContentProp('comment');
const setStatus = setDialogContentProp('status');

const mapStateToProps = ({
  dialog: {
    contentProps: {
      buttons = [],
      status,
      withComment = true,
      withColor = true,
      multiSelect = false,
      comments,
      justify,
    },
  },
  users = [],
  connectedUser
}) => ({
  justify,
  buttons,
  status,
  withComment,
  withColor,
  multiSelect,
  comments,
  users,
  user: connectedUser
});

const styles = {
  gridItem: {
    display: 'flex',
    flexGrow: 1,
    minHeight: 80
  },
  subStatusHeader: {
    borderTop: '2px solid #ccc',
    margin: '10px 0',
    paddingTop: '10px',
    fontWeight: 'bold',
    color: '#666'
  }
};

const mapDispatchToProps = {
  setComment: e => setComment(e.target.value),
  setStatus: e => setStatus(e),
};

const categorizeButtons = (buttons = []) =>
  buttons.reduce((acc, btn) => {
    if (btn.category === null || btn.category === undefined) {
      acc.main.push(btn);
    } else {
      if (!acc.subStatuses[btn.category]) {
        acc.subStatuses[btn.category] = [];
      }
      acc.subStatuses[btn.category].push(btn);
    }
    return acc;
  }, { main: [], subStatuses: {} });

const getSelectedCategory = (buttons = [], status) => {
  const currentStatus = Array.isArray(status) ? status : [status];
  const selectedButton = buttons.find(b => currentStatus.includes(b._id));

  if (!selectedButton) {
    return null;
  }

  if (
    selectedButton.category !== null &&
    selectedButton.category !== undefined
  ) {
    return selectedButton.category;
  }

  return selectedButton._id;
};

const DialogStatusWithComment = ({
  buttons, classes, status, setStatus, justify = '',
  setComment, comments, withComment,
  withColor, multiSelect, users, user
}) => {
  const categorizedButtons = React.useMemo(
    () => categorizeButtons(buttons),
    [buttons]
  );

  const currentStatus = Array.isArray(status) ? status : [status];
  const selectedCategory = getSelectedCategory(buttons, status);
  const hasSubStatuses = Object.keys(categorizedButtons.subStatuses).length > 0;

  const categoryHasSubStatuses = (categoryId) =>
    categorizedButtons.subStatuses[categoryId]?.length > 0;

  const handleCategoryClick = (categoryId) => {
    if (!categoryHasSubStatuses(categoryId)) {
      setStatus(multiSelect ? status.toggleValue(categoryId) : categoryId);
    } else {
      setStatus(categoryId);
    }
  };

  const showSubStatuses =
    hasSubStatuses &&
    selectedCategory !== null &&
    categorizedButtons.subStatuses[selectedCategory];

  return (
    <Grid container spacing={3} justifyContent={justify}>
      {categorizedButtons.main.map((category) =>
        <Grid key={`${category._id}-${category.name}Grid`}
          item sm={hasSubStatuses ? 6 : 4} className={classes.gridItem}>
          <Button
            fullWidth
            color={selectedCategory === category._id ? 'secondary' : 'primary'}
            style={
              withColor && category.color
                ? { backgroundColor: category.color[500] }
                : {}
            }
            variant="contained"
            onClick={() => handleCategoryClick(category._id)}>
            {category.name}
          </Button>
        </Grid>
      )}

      {showSubStatuses && (
        <>
          <Grid item xs={12}>
            <Typography className={classes.subStatusHeader}>
              Détails :
            </Typography>
          </Grid>
          {categorizedButtons.subStatuses[selectedCategory].map((subStatus) =>
            <Grid key={`${subStatus._id}-${subStatus.name}Grid`}
              item sm={4} className={classes.gridItem}>
              <Button
                fullWidth
                color={
                  currentStatus.includes(subStatus._id)
                    ? 'secondary'
                    : 'primary'
                }
                style={
                  withColor && subStatus.color
                    ? { backgroundColor: subStatus.color[500] }
                    : {}
                }
                variant="contained"
                onClick={() =>
                  setStatus(
                    multiSelect
                      ? status.toggleValue(subStatus._id)
                      : subStatus._id
                  )
                }>
                {subStatus.name}
              </Button>
            </Grid>
          )}
        </>
      )}

      {withComment && (
        <Grid item xs={12}>
          <CommentsList
            setOnChange={setComment}
            users={users}
            user={user}
            comments={fromJS(comments || [])}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(DialogStatusWithComment, styles)
);
